import type { RouteNavigationParams } from './router'

const ROUTE_GROUPS: Record<string, string> = {
  'provider-owner-repo-run-runId': 'run'
}

// Sorted by prefix length descending so longest prefix wins
const SORTED_PREFIXES = Object.keys(ROUTE_GROUPS).sort((a, b) => b.length - a.length)

export function getRouteGroup(routeName: string): string | null {
  if (!routeName) return null
  for (const prefix of SORTED_PREFIXES) {
    if (routeName === prefix || routeName.startsWith(prefix + '-')) {
      return ROUTE_GROUPS[prefix]
    }
  }
  return null
}

const STORAGE_KEY_PREFIX = 'entry-referrer:'

export function getStoredEntryReferrer(group: string): RouteNavigationParams | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY_PREFIX + group)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed?.name ? parsed : null
  } catch {
    return null
  }
}

export function setStoredEntryReferrer(group: string, route: RouteNavigationParams): void {
  try {
    sessionStorage.setItem(
      STORAGE_KEY_PREFIX + group,
      JSON.stringify({ name: route.name, params: route.params, query: route.query })
    )
  } catch {
    // sessionStorage may be unavailable (SSR, private browsing quota)
  }
}

export function clearStoredEntryReferrer(group: string): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY_PREFIX + group)
  } catch {
    // sessionStorage may be unavailable
  }
}
